'use strict';

var _ = require('lodash');
var d3 = require('d3');
var PinLine = function PinLine(ChartElementsConstants) {
  return function () {
    var scales;
    var params;
    var dispatch;
    var selectedDtd;
    var pin;
    var classPrefixes = ['first', 'second', 'third', 'fourth'];
    var pinLineData;
    var pinLineContainer;
    var clipPath;
    function appendPin(container) {
      pinLineContainer = container;
      container.selectAll('g.pin').remove();
      pin = container.append('g').attr('class', 'pin').style('display', 'none');

      // add circles
      classPrefixes.forEach(function (classPrefix) {
        pin.append('circle').attr('class', 'pin-circle ' + classPrefix + '-circle').attr('r', 4.5);
      });

      // vertical line
      pin.append('line').attr('class', 'pin-line').attr('y1', 0).attr('y2', 1);

      // add texts and shadows
      classPrefixes.forEach(function (classPrefix) {
        pin.append('text').attr('class', 'pin-text ' + classPrefix + '-pin-text shadow').attr('x', 0).attr('dy', '.35em');
        pin.append('text').attr('class', 'pin-text ' + classPrefix + '-pin-text').attr('x', 0).attr('dy', '.35em');
      });
      if (clipPath) {
        pin.attr('clip-path', clipPath);
      }
    }
    function movePin(selectedDataPoints) {
      var translateX,
        textX,
        minimumDeltaY = 15;
      function drawLine() {
        // we hide circles and texts
        pin.selectAll('.pin-circle').style('display', 'none');
        pin.selectAll('.pin-text').style('display', 'none');

        // move pin line
        pin.select('.pin-line').attr('transform', 'translate(' + translateX + ', 0)').attr('y2', params.height);

        // show whole pin
        pin.style('display', null);
      }
      function drawCircle(point, classPrefix) {
        pin.select('.' + classPrefix + '-circle').attr('transform', 'translate(' + translateX + ',' + point.translateY + ')').style('display', null);
      }
      function drawText(point, classPrefix) {
        pin.selectAll('.' + classPrefix + '-pin-text').attr('x', textX).attr('y', point.textY).text(point.pinLineLabel + ' (' + point.x + ', ' + point.y + ')').style('display', null);
      }
      function computeCoordinatesX(point) {
        translateX = scales.xScale(point.x);
        textX = translateX + 8;

        // if focus line is too close to right edge of chart we need to move text
        // so it is not getting outside of the graph area
        if (translateX > params.width - 75) {
          textX -= 75;
        }
      }
      selectedDataPoints.forEach(function (point, index) {
        // move text up so it is not colliding with x axis
        point.translateY = scales.yScale(point.y);
        point.textY = point.translateY;
        if (index === 0) {
          computeCoordinatesX(point);
          drawLine();
        } else {
          // compute Y difference between two points
          var previousCoordinateY = selectedDataPoints[index - 1].textY;
          var delta = previousCoordinateY - point.textY;
          if (delta < minimumDeltaY) {
            point.textY = previousCoordinateY - minimumDeltaY;
          }
        }
        drawCircle(point, classPrefixes[index]);
        drawText(point, classPrefixes[index]);
      });
      return selectedDataPoints;
    }
    function getPinLineData(curves) {
      var pinData = [];
      curves.forEach(function (curve) {
        curve.curveData.forEach(function (item) {
          pinData.push({
            pinLineLabel: curve.pinLineLabel,
            x: item.dtd,
            y: item.value
          });
        });
      });
      return pinData;
    }
    function areCurrentData(dataPoints) {
      return _.findIndex(dataPoints, {
        pinLineLabel: ChartElementsConstants.PIN_LINE.CURRENT
      }) !== -1;
    }
    function findDataPoints(pinLineData) {
      var dataPoints = _.filter(pinLineData, function (item) {
        return selectedDtd === item.x;
      });
      if (!areCurrentData(dataPoints)) {
        return [];
      }
      return _.sortBy(dataPoints, function (point) {
        return point.y;
      });
    }
    var pinLine = function pinLine(container) {
      pinLineData = getPinLineData(_.filter(container.datum(), function (datumItem) {
        return datumItem.curveData;
      }));
      appendPin(container);
      container.select('rect.overlay').on('mouseup', function () {
        selectedDtd = Math.round(scales.xScale.invert(d3.mouse(this)[0]));
        var selectedDataPoints = findDataPoints(pinLineData);
        movePin(selectedDataPoints);
        if (selectedDataPoints.length > 0) {
          dispatch.pindown(selectedDtd);
        }
      });
      movePin(findDataPoints(pinLineData));
    };
    pinLine.scales = function (value) {
      if (!arguments.length) {
        return scales;
      }
      scales = value;
      return pinLine;
    };
    pinLine.params = function (value) {
      if (!arguments.length) {
        return params;
      }
      params = value;
      return pinLine;
    };
    pinLine.setSelectedDtd = function (dtd) {
      selectedDtd = dtd;
      movePin(findDataPoints(pinLineData));
      return pinLine;
    };
    pinLine.clipPath = function (value) {
      clipPath = 'url(' + value + ')';
      return pinLine;
    };

    /**
     * Cleans up event handlers
     */
    pinLine.destroy = function () {
      pinLineContainer.select('rect.overlay').on('mouseup', null);
    };
    dispatch = d3.dispatch('pindown');
    return d3.rebind(pinLine, dispatch, 'on');
  };
};
PinLine.$inject = ['ChartElementsConstants'];
module.exports = PinLine;